import Vue from 'vue'
import Router from 'vue-router'
import innerChildren from './inner/inner'
import investment from './other/investment'
import stocks from './stocks.js'
import coupon from './coupon.js'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/fr',
      redirect: '/fr/app'
    },
    {
      path: '/fr/app',
      component: resolve => {
        require(['../apps.vue'], resolve)
      },
      children: [{ //内部赋权首页
          path: 'jf_inner',
          component: resolve => {
            require(['../views/jf_inner.vue'], resolve)
          }
        },
        { //内部赋权首页
          path: 'p5',
          component: resolve => {
            require(['../views/p5.vue'], resolve)
          }
        },
        { //内部赋权首页
          path: 'p6',
          component: resolve => {
            require(['../views/p6.vue'], resolve)
          }
        },
        { //会员中心
          path: 'inner',
          component: resolve => {
            require(['../views/inner/base.vue'], resolve)
          },
          children: innerChildren
        },
        { //沪深行情
          path: 'stock',
          name: 'stock',
          component: resolve => {
            require(['../views/stock/base.vue'], resolve)
          },
          children: stocks
        },
        { //投资决策
          path: 'investment',
          component: resolve => {
            require(['../views/investment/base.vue'], resolve)
          },
          children: investment
        },
        { //登录
          path: 'login',
          component: resolve => {
            require(['../views/login.vue'], resolve)
          },
          meta: {
            title: '登录'
          }
        },
        { //营销
          path: 'Marketing',
          component: resolve => {
            require(['../views/Marketing.vue'], resolve)
          },
          meta: {
            title: '营销'
          }
        },
        { //登录
          path: 'my',
          component: resolve => {
            require(['../views/myself/base.vue'], resolve)
          },
          children: [{
            path: 'index',
            component: resolve => {
              require(['../views/myself/index.vue'], resolve)
            },
          }, {
            path: 'personalTailor',
            name: "personal-tailor",
            component: resolve => {
              require(['../views/inner/forinner/personal.vue'], resolve)
            }
          }, {
            path: 'aboutUs',
            name: "aboutUs",
            component: resolve => {
              require(['../views/myself/aboutUs.vue'], resolve)
            }
          }]
        },
        { //盘中解析
          path: 'pzjx',
          component: resolve => {
            require(['../views/inner/pzjx/index.vue'], resolve)
          }
        },
        { //巨丰头条详情
          path: 'jftc',
          component: resolve => {
            require(['../views/inner/jftc/details.vue'], resolve)
          }
        },
        { //投资必读详情
          path: 'tzbd',
          component: resolve => {
            require(['../views/inner/tzbd/details.vue'], resolve)
          }
        },
        { //王牌产品模块列表详情
          path: 'tgTeam',
          component: resolve => {
            require(['../components/tgTeam.vue'], resolve)
          }
        },
        { //看好中国文章页
          path: 'seeDetails',
          component: resolve => {
            require(['../views/investment/wzDetails.vue'], resolve)
          }
        },
        { //其他文章页
          path: 'details',
          name: 'common-details-page',
          component: resolve => {
            require(['../views/investment/details.vue'], resolve)
          }
        },
        { //主题投资文章订阅页
          path: 'buy',
          component: resolve => {
            require(['../views/investment/buy.vue'], resolve)
          }
        },
        { //主题投资文章购买页
          path: 'order_form',
          component: resolve => {
            require(['../views/investment/order_form.vue'], resolve)
          },
          meta: {
            keepAlive: true
          }
        },
        { //主题投资文章购买成功页
          path: 'success',
          component: resolve => {
            require(['../views/investment/success.vue'], resolve)
          }
        },
        {
          path: 'voucher',
          name: 'voucher',
          component: resolve => {
            require(['@/views/investment/voucher.vue'], resolve)
          }
        },
        {
          path: 'instructions',
          name: 'instructions',
          component: resolve => {
            require(['@/views/investment/instructions.vue'], resolve)
          }
        },
        { //风险测评
          path: 'sign',
          name: 'sign',
          component: resolve => {
            require(['@/views/investment/sign_4.vue'], resolve)
          }
        },
        { //协议
          path: 'riskBook',
          name: 'riskBook',
          component: resolve => {
            require(['@/views/investment/riskBook.vue'], resolve)
          }
        },
        { //支付中心
          path: 'payCtl',
          name: 'payCtl',
          component: resolve => {
            require(['@/views/investment/payCtl.vue'], resolve)
          }
        },
        { //支付中心
          path: 'pc',
          name: 'pc',
          component: resolve => {
            require(['@/views/myself/pc.vue'], resolve)
          }
        },
        { //数据研判列表
          path: 'articleList',
          name: 'articleList',
          component: resolve => {
            require(['@/views/investment/articlelist.vue'], resolve)
          }
        },
        { //荐股列表
          path: 'history',
          name: 'history',
          component: resolve => {
            require(['@/views/inner/history.vue'], resolve)
          }
        },
        { //荐股列表
          path: 'jfng_details',
          name: 'jfng_details',
          component: resolve => {
            require(['@/views/inner/product/jfng_details.vue'], resolve)
          }
        },
        // { //财经大咖
        //   path: 'cjdk',
        //   name: 'cjdk',
        //   component: resolve => {
        //     require(['@/views/inner/product/cjdk.vue'], resolve)
        //   }
        // },
        { //往期嘉宾
          path: 'cjdk-explain',
          name: 'cjdk-explain',
          component: resolve => {
            require(['@/views/inner/product/cjdk-explain.vue'], resolve)
          }
        },
        { //问股详情页-ai诊股
          path: 'ai',
          name: 'ai',
          component: resolve => {
            require(['@/views/inner/product/askTheStock/aiDiagnosis.vue'], resolve)
          }
        },
        { //问股首页
          path: 'aiHome',
          name: 'aiHome',
          component: resolve => {
            require(['@/views/inner/product/askTheStock/index.vue'], resolve)
          }
        },
        { //问股记录
          path: 'stockRecord',
          name: 'stockRecord',
          component: resolve => {
            require(['@/views/inner/product/askTheStock/stockRecord.vue'], resolve)
          }
        },
        { //问股记录(无配图)
          path: 'historyRecords',
          name: 'historyRecords',
          component: resolve => {
            require(['@/views/inner/product/askTheStock/historicalRecords.vue'], resolve)
          }
        },
        { //图文详情
          path: 'graphText',
          name: 'graphText',
          component: resolve => {
            require(['@/views/inner/product/graphicAndText.vue'], resolve)
          }
        },
        { //风险揭示说明
          path: 'disclosureStatement',
          name: 'disclosureStatement',
          component: resolve => {
            require(['@/views/disclosureStatement.vue'], resolve)
          }
        },
        { //说明
          path: 'explain',
          name: 'explain',
          component: resolve => {
            require(['@/views/inner/product/explain.vue'], resolve)
          }
        },
        {
          path:'coupon',
          name: 'coupon',
          component: resolve => {
            require(['@/views/Coupon/base.vue'], resolve)
          },
          children:coupon
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js